export type Patch = {
   '@@isPatch': boolean;
   operations: PatchOperation[];
};

export type PatchOperation = SetOperation | RemoveOperation;

export type SetOperation = {
   type: 'set';
   path: string;
   value: any;
};

export type RemoveOperation = {
   type: 'remove';
   path: string;
};

export function isPatch(x: any): x is Patch {
   return x && x['@@isPatch'];
}
